var map = {
	"./gallery_00.jpg": 2101,
	"./gallery_01.jpg": 2102,
	"./gallery_02.jpg": 2103,
	"./gallery_03.jpg": 2104,
	"./gallery_04.jpg": 2105,
	"./gallery_05.jpg": 2106,
	"./gallery_06.jpg": 2107,
	"./gallery_07.jpg": 2108,
	"./gallery_08.jpg": 2109,
	"./gallery_09.jpg": 2110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2100;